import { addons } from '@storybook/manager-api';
import { create } from '@storybook/theming';
import { light } from '@mewssystems/design-tokens';
import { StoriesRoots } from '@optimus-web/core';

const normalizeRootToId = (root: string) => root.toLowerCase().replace(/\s/, '-');

export const baseTheme = create({
    base: 'light',

    brandTarget: '_blank',
    brandUrl: 'https://www.mews.design/',

    appBorderRadius: light.BORDER_RADIUS_100,
    inputBorderRadius: light.BORDER_RADIUS_100,
});

addons.setConfig({
    theme: baseTheme,
    sidebar: {
        collapsedRoots: normalizeRootToId(StoriesRoots.Helpers),
    },
});
